import React, {useContext, useEffect, useRef, useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import LinkOnIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';
import { GetAppOutlined, HomeOutlined, AccountBalanceOutlined, Drafts, MailOutline, HomeWorkOutlined, Edit, KeyboardArrowUp, KeyboardArrowDown, Timeline, Replay } from '@mui/icons-material';
import { Radio, Tooltip,LinearProgress, Button, Collapse, Container, IconButton, Menu, MenuItem, Modal, Stack, FormControlLabel, Checkbox } from "@mui/material";

import { fetchSignedUrlFromS3 } from '../../utility/helper';
import { getStringToDate } from "../../utility/get-formated-date";
import useInfiniteScroll from '../../hooks/useInfiniteScroll';

import './hoa-table-layout.scss';
import config from "../../hoa-config";
import datastore from '../../store/hoa-datastore';
import { useSelectedTaskStoreStore } from '../../store/useTaskStore';
import { GlobalContext } from "../../context/hoa-global-context";
import dashboardServices from "../../services/hoa-dashboard-api-service";
import MailLogComponent from "./modals/mailLogComponentModal";
import DocumentLogComponent from "./modals/documentLogComponentModal";

const toolbar = 64;
const filterComponent = 102;
const padding = 32;
const tableHeader = 48;
const tableBodyColumnHeight = 60;
const responsiveHeight = toolbar + filterComponent + padding + tableHeader + 1;

const columnSize:any = {
    'Municipality':5,
    'Hoa':9,
    'Property':8,
    'Mail':6,
    'Email': 6,
    'Requests': 4,
    'DataFieldConfigurator': 5, 
    'Document': 10,
    'Webhook': 4,
    'TriggerNotificationLog': 5,
    'PropertiesModalTable': 7
}


export default function TableLayout(props: any) {
    const { activeMenu, changeActiveMenu } = useContext<any>(GlobalContext);
    const { headers, columns, tagType, fetchResult, updateSelectedValues, updateView, isAssigningMailToProperty, handleMailAssignedToProperty, selectedProperty, updateDocument, updateRequest, updateMail, downloadDocument, removeRequestData, editModalOpen, setEditModalOpen, retryWebhook } = props;

    const numberOfProjects = Math.ceil((window.innerHeight - responsiveHeight) / 60)
    const [openRequestId, setOpenRequest] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [accordionData, setAccordionData] = useState('');
    const [mailOrEmail, setMailOrEmail] = useState(null);

    const [modalOpen, setModalOpen] =useState(false);
    const [toBeDeletedItem, setToBeDeletedItem] =useState({});
    const [openedDocumentId, setOpenedDocumentId] = useState(null);
    const [selectedDocumentId, setSelectedDocumentId] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [isMailLogModalOpen, setMailLogModalOpen] = useState(false);
    const [selectedMails, updateSelectedMails] = useState([]);
    const [isMailLoading, updateIsMailLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isDocumentLogModalOpen, setDocumentLogModalOpen] = useState(false);
    const { updateSelectedTask } = useSelectedTaskStoreStore()

    const open = Boolean(anchorEl);

    const handleDeleteClose = () => {
        setModalOpen(!modalOpen);
    }

    const mailLogModalClose = () => {
        setMailLogModalOpen(!isMailLogModalOpen);
    }

    const documentLogModalClose = () => {
        setDocumentLogModalOpen(!isDocumentLogModalOpen);
    }
    
    const handleClick = (event: React.MouseEvent<HTMLElement>, objectId: string) => {
        setAnchorEl(event.currentTarget);
        setSelectedDocumentId(objectId);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setSelectedDocumentId(null);
    };

    const handleRowStatusClick = (event: React.MouseEvent<HTMLElement>, objectId: string) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setSelectedRowId(objectId);
    };
    const handleRowStatusClose = (event: any) => {
        event.stopPropagation();
        setAnchorEl(null);
        setSelectedRowId(null);
    };

   

    const extractData = async (objectId:string) => {
        setLoading(true);
        if(tagType === 'Hoa') {
            const hoaData = await dashboardServices.getHoaById(objectId, datastore.selectedOrganization?.id);
            updateSelectedValues(hoaData.data);
        } else if (tagType === 'Municipality') {
            const munciData = await dashboardServices.getMunicipalityById(objectId);
            updateSelectedValues(munciData.data);
        } else if (tagType === 'Email') {
            const emailData = await dashboardServices.getEmailById(objectId);
            updateSelectedValues(emailData.data);
        } else if (tagType === 'Mail') {
            const mailData = await dashboardServices.getMailById(objectId);
            updateSelectedValues(mailData.data);
        } else if (tagType === 'Property') {
            const propertyData = await dashboardServices.getPropertyById(objectId);
            updateSelectedValues(propertyData.data);
        }
        setLoading(false);
    }
    
    const startEditTimerForMailVerified = (option:any) => {
        if(option === 'update' && tagType === 'Property' && activeMenu === 'propertiespendingtask') {
            datastore.setStartTime();
        }
    }

    const onIconBtnClick = async (e: any, data:any,option:any, tagType?:any) => {
        updateSelectedValues({});
        startEditTimerForMailVerified(option)
        if(activeMenu === 'propertiespendingtask') {
            updateSelectedTask({...data});
        }
        if(option === 'modal-update'){
            e.stopPropagation();
            updateSelectedValues(data);
            setEditModalOpen(true);
        }
        if(tagType === "DataFieldConfigurator"){
            e.stopPropagation()
            updateSelectedValues(data.content);
            changeActiveMenu(activeMenu, true, data.objectId, -1, option);
            updateView(option);
        }
        if (tagType !== "DataFieldConfigurator" && tagType != "Webhook" && tagType != "TriggerNotificationLog" && tagType != "Mail" && tagType != "Requests" && tagType != "Document" && !isAssigningMailToProperty) {
            e.stopPropagation();
            updateSelectedValues(data);
            await extractData(data.objectId);
            changeActiveMenu(activeMenu, true, data.objectId, -1, option);
            updateView(option);
        }
        if(tagType === 'Mail'){
            e.stopPropagation();
            updateSelectedValues(data);
            await extractData(data.objectId);
            changeActiveMenu(activeMenu, true, data.objectId, -1, option);
            updateView(option);
        }
    }

    const onDeleteIconClick = (e: any, data: any) =>{
        e.stopPropagation();
        setModalOpen(!modalOpen);
        setToBeDeletedItem(data);
    }

    const toggleDocumentDetails = (documentId: any) => {
        if(openedDocumentId == documentId) {
            setOpenedDocumentId(null);
        }
        else {
            setOpenedDocumentId(documentId);
        }
    }

    const tableRowWidth = (index: number) => {
        const unit = Math.floor(datastore.responsiveWidthOfMainDashboard / columnSize[tagType]);
        if(tagType == "Requests") {
            if(index == 1) {
                return `${unit+(unit/2)}px`;
            }
            else if(index == 2) {
                return `${unit*2}px`;
            }
            else {
                return `${unit/2}px`;
            }
        }
        if (tagType == "DataFieldConfigurator") {
            if (index == 0) {
                return `${unit/2}px`;
            }
            else if (index == 1) {
                return `${unit * 2}px`;
            }
            else if (index == 2) {
                return `${unit}px`
            }
            else {
                return `${unit/2}px`;
            }
        }
        if(tagType === 'Document'){
            if(index == 1){
                return `${unit*1.5}px`;
            }
            else{
                return `${unit}px`;
            }
        }
        if(tagType === 'Property'){
            if(index == 1){
                return `${unit/1.5}px`;
            }
            if(index == 6){
                return `${unit/1.5}px`;
            }
            if(index == 7){
                return `${unit/1.5}px`;
            }
            else{
                return `${unit}px`;
            }
        }
        if(tagType === 'Mail' || tagType === 'Email') {
            if(index === 0) return '50px';
            return `${unit}px`;
        }
        else {
            return `${unit}px`;
        }
    }

    const tableRef = useRef(null)
    const { isFetching, rows, count } = useInfiniteScroll(tableRef, fetchResult, tagType, numberOfProjects)

    const isBottomBorderAvailable =
        (window.innerHeight - responsiveHeight - tableHeader) >= (rows.length * tableBodyColumnHeight) ? false : true;
    
    const handleAccordion = (row: any) =>{
        if(row.objectId === openRequestId){
            setOpenRequest(null)
            setAccordionData('')
            return;
        }else{
            setOpenRequest(row.objectId);
            setAccordionData(row.description)
        }
    }

    const renderTriggerNotificationLogStatus = (status: boolean) => {
        let backgroundColor = "";
        let text = "";

        if (status) {
            backgroundColor = "#E8F5EC";
            text = "Success";
        }
        else {
            backgroundColor = "#FFECB3";
            text = "Failed";
        }

        return <div style={{ background: backgroundColor, padding: "5px 15px 5px 15px", textAlign: "start", borderRadius: 4, fontWeight: 500, width: 60 }}>{text}</div>
    }

    const renderDocumentStatus = (status: string, objectId: any) => {
        if(!status) {
            return ( <></> );
        }

        var backgroundColor = "";
        config.documentMenuItem.map((item: any) => {
            if(item.key.toLowerCase() == status.toLowerCase()) {
                backgroundColor = item.color;
            }
        })

        return (
            <div style={{ display: "flex"}}>
                <div style={{ background: backgroundColor, padding: "5px 15px 5px 15px", textAlign: "center", borderRadius: 4, fontWeight: 500, minWidth: 80 }}>
                    {status}
                </div>
                <Tooltip title="Change status">
                    <IconButton
                        style={{backgroundColor: '#C5C5C5', borderRadius: '50%', marginLeft: '10px', height: '22px', width: '22px', marginTop: '5px'}}
                        onClick={(e) => handleClick(e, objectId)}
                        size="small"
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <KeyboardArrowDown/>
                    </IconButton>
                </Tooltip>
                <Menu
                    elevation={0}
                    PaperProps={{
                        className: "status-menu-box"
                    }}
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    {config.documentMenuItem.map((item: any, index: number) => {
                        return (
                            <MenuItem key={item.key} onClick={() => {stateUpdate(selectedDocumentId, item.value); updateDocument(selectedDocumentId, item.value)}}>
                                <div style={{display: "flex"}}>
                                    <div style={{ height: 15, width: 15, marginRight: 5, borderRadius: 8, backgroundColor: item.menuItemColor }}></div>
                                    <div style={{ fontSize: 14, fontWeight: 500 }}>{item.value}</div>
                                </div>
                            </MenuItem>
                        )
                    })}
                </Menu>
            </div>
        )
    }

    const stateUpdate = (id: any, status: string) => {
        rows.find((row: any, index: number) => {
            if(row.objectId === id){
                row.status = status;
                row.lastUpdatedBy = datastore.ownerInformation.email;
            }
        })
    }

    const renderRequestStatus = (status: string, objectId: any) => {
        if(!status) {
            return ( <></> );
        }

        var backgroundColor = "";
        config.requestMenuItem.map((item: any) => {
            if(item.key.toLowerCase() == status.toLowerCase()) {
                backgroundColor = item.color;
            }
        })

        return (
            <div style={{ display: "flex" }}>
                <div style={{ background: backgroundColor, padding: "5px 15px 5px 15px", textAlign: "center", borderRadius: 4, fontWeight: 500, minWidth: 80 }}>
                    {status}
                </div>
                <Tooltip title="Change status">
                    <IconButton
                        style={{backgroundColor: '#C5C5C5', borderRadius: '50%', marginLeft: '10px', height: '22px', width: '22px', marginTop: '5px'}}
                        onClick={(e) => handleRowStatusClick(e, objectId)}
                        size="small"
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <KeyboardArrowDown/>
                    </IconButton>
                </Tooltip>
                <Menu
                    elevation={0}
                    PaperProps={{
                        className: "status-menu-box"
                    }}
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleRowStatusClose}
                    onClick={handleRowStatusClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    {config.requestMenuItem.map((item: any, index: number) => {
                        return (
                            <MenuItem key={item.key} onClick={() => {stateUpdate(selectedRowId, item.value); updateRequest(selectedRowId, item.value)}}>
                                <div style={{display: "flex"}}>
                                    <div style={{ height: 15, width: 15, marginRight: 5, borderRadius: 8, backgroundColor: item.menuItemColor }}></div>
                                    <div style={{ fontSize: 14, fontWeight: 500 }}>{item.value}</div>
                                </div>
                            </MenuItem>
                        )
                    })}
                </Menu>
            </div>
        )
    }

    const renderHoaType = (masterHoa:any) => {
        let backgroundColor = '';
        let type = '';

        if (masterHoa) {
            backgroundColor = "#EDE7F6";
            type = 'Sub-HOA';
        }
        else {
            backgroundColor = '#FFECB3';
            type = 'Master HOA'
        }

        
        return (
            <div style={{ background: backgroundColor, padding: "5px 15px 5px 15px", textAlign: "center", borderRadius: 4, fontWeight: 500, minWidth: 60, width: 80 }}>
                {type}
            </div>
        );
    }

    const renderMailStatus = (status: string, objectId: any) => {
        if(!status) {
            return ( <></> );
        }

        var backgroundColor = "";
        config.mailMenuItem.map((item: any) => {
            if(item.key.toLowerCase() == status.toLowerCase()) {
                backgroundColor = item.color;
            }
        })

        return (
            <div style={{ display: "flex" }}>
                <div style={{ background: backgroundColor, padding: "5px 10px 5px 10px", textAlign: "center", borderRadius: 4, fontWeight: 500, minWidth: 80 }}>
                    {status}
                </div>
                {
                    status != 'Assigned' && status != 'Non-assignable' &&
                    <Tooltip title="Change status">
                        <IconButton
                            style={{backgroundColor: '#C5C5C5', borderRadius: '50%', marginLeft: '10px', height: '22px', width: '22px', marginTop: '5px'}}
                            onClick={(e) => handleRowStatusClick(e, objectId)}
                            size="small"
                            aria-controls={open ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                        >
                            <KeyboardArrowDown/>
                        </IconButton>
                    </Tooltip>
                }
                <Menu
                    elevation={0}
                    PaperProps={{
                        className: "status-menu-box"
                    }}
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleRowStatusClose}
                    onClick={handleRowStatusClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    {config.mailMenuItem.filter((each: any) => each.key != 'Assigned' && each.key != 'Non-assignable').map((item: any, index: number) => {
                        return (
                            <MenuItem key={item.key} onClick={() => {updateMail(selectedRowId, item.value); stateUpdate(selectedRowId, item.value)}}>
                                <div style={{display: "flex"}}>
                                    <div style={{ height: 15, width: 15, marginRight: 5, borderRadius: 8, backgroundColor: item.menuItemColor }}></div>
                                    <div style={{ fontSize: 14, fontWeight: 500 }}>{item.value}</div>
                                </div>
                            </MenuItem>
                        )
                    })}
                </Menu>
            </div>
        )
    }
    const validColumnValue = (value:any,index:number,objectId:any, row: any) => {
        if(tagType === 'Document') {
            if(index == 8) {
                return value?.name || 'N/A';
            }
            if(index == 6) {
                return (
                    renderDocumentStatus(value, objectId)
                )
            }
            else if(index === 5){
                return (
                    getStringToDate(value)
                )
            }
            else {
                if(typeof value === "number"){
                    return value;
                } else {
                    return value || 'N/A';
                }
            }
        }
        else if (tagType === "TriggerNotificationLog") {
            if (index === 4) {
                return renderTriggerNotificationLogStatus(value);
            }
            else if (index === 2 && value) {
                return new Date(value).toLocaleDateString('en-US');
            }
            else {
                if(typeof value === "number"){
                    return value;
                } else {
                    return value || 'N/A';
                }
            }
        }
        else if(tagType === "DataFieldConfigurator") {
            //!Descriptions
            if (index === 1) {
                return `${config.HOA_CONFIG_DESCRIPTION} - ${props.selectedDataConfigOrg}`
            } else {
                return value || 'N/A';
            }
        }
        else if (tagType === "Property" && activeMenu === 'propertiespendingtask') {
            if(index === 0 || index === 2 || index === 5) {
                return value || 'N/A'
            }
            if(index === 1) {

                let documents = []
                if(value === 'mail') {
                    documents.push(row?.mailDetails?.documentUrl)
                }else if(value === 'email') {
                    documents = [...row?.emailDetails?.documentUrl]
                }

                const handleClick = async (event:any, document: any) => {
					event.stopPropagation();
                    const isPdf = document.includes('.pdf') ? true : false;
					const { data } = await dashboardServices.getSignedUrl(
						document,
						"",
						isPdf
					);
					window.open(data, "_blank");
				};

				return (
					<div style={{ display:'flex', flexDirection:'column'}}>
						{documents.map((document: string, index: number) => {
							return (
								<a
									style={{
										background: "none",
										border: "none",
										color: "blue",
										textDecoration: "underline",
										cursor: "pointer",
										fontSize: "inherit",
									}}
									onClick={(event: any) => handleClick(event, document)}
								>
									Document-{index + 1}
								</a>
							);
						})}
					</div>
				);
            }
            if(index === 3) {
                return value?.externalId || 'N/A';
            }
            if(index === 4) {
                return value || 'N/A';
            }
            if(index === 6) {
                const capitalizeFirstWord = (str:string) => str?.[0]?.toUpperCase() + str?.slice(1) || '';
                return capitalizeFirstWord(value) || 'N/A';
            }
            if(index === 7) {
                return new Date(value).toLocaleDateString()
            }
            // if(index === 8) {
            //     if(value && value == 'external'){
            //         return <span style={{borderRadius: '50px', backgroundColor: 'aqua', padding: '8px', textTransform: "capitalize"}}>{value}</span>
            //     }else{
            //         return<span></span>
            //     }
            // }
            return  'N/A';
        }
        else if (tagType === "Property" && isAssigningMailToProperty) {
            if (index === 0) {
                return value?.externalId || 'N/A';
            } else if (index === 2) {
                return value?.city || 'N/A';
            } else if (index === 5) {
                return value?.market || 'N/A';
            }
            else {
                return value || 'N/A';
            }
        }
        else{
            if(tagType === 'Requests'){
                if(index === 3){
                    return(
                        renderRequestStatus(value, objectId)
                    )
                }
            }
            if(tagType === 'Mail'){
                if(index === 5){
                    return(
                        renderMailStatus(value, objectId)
                    )
                }
                if(index === 1) {
                    return value?.name
                }
                if(index === 2) {
                    return value?.address
                }
                if(index === 3) {
                    return value?.name
                }
                if(index === 4) {
                    return value?.address
                }
                if(index === 6 && value) {
                    return new Date(value).toLocaleDateString('en-US');
                }
                if(index === 13) {
                    return value?.name
                }
            }
            if(tagType === 'Hoa') {
                if (index == 1) {
                    return value?.propertyManagerName || 'N/A';
                }
                if (index === 7) {
                    return (
                        renderHoaType(value)
                    )
                }
            }
            if(tagType === 'Email'){
                if(index === 3){
                    return(
                        renderMailStatus(value, objectId)
                    )
                }
                if(index === 2) {
                    return value ? value.join(', ') : "N/A"
                }
                if(index === 5 && value){
                    return new Date(value).toLocaleDateString('en-US', { timeZone: 'UTC' });
                }
            }
            if(tagType !== 'Property') {
                if(typeof value === "number"){
                    return value;
                } else {
                    if(tagType === "Requests" && index === 2){
                        return value.slice(0,50).concat(`...`);
                    }else{
                        return value || 'N/A';
                    }
                }
            }
            else{
                if(index === 2) {
                    return value?.city || 'N/A';
                } else if(index === 1) {
                    return value?.externalId || 'N/A';
                } else if (index === 4){
                    return value?.market || 'N/A';
                } else if(index === 6){
                    if(value){
                        return <div className="tag-item"><LinkOnIcon /><span>Linked</span></div>
                    }else{
                        return <div className="tag-item"><LinkOffIcon /><span>Unlinked</span></div>
                    }
                } else if(index === 7){
                    if(value && value == 'external'){
                        return <span style={{borderRadius: '50px', backgroundColor: 'aqua', padding: '8px', textTransform: "capitalize"}}>{value}</span>
                    }else{
                        return<span></span>
                    }
                }
                return value || 'N/A';
            }
        }
    }
    
    if (window.innerWidth <= 768) {
        return (
            <>
                {isFetching || loading ? <LinearProgress style={{ height: "2px" }} /> : null}
                {responsiveTable(headers, tableRef, rows, columns, isFetching, isBottomBorderAvailable,tagType, onIconBtnClick, validColumnValue, onDeleteIconClick, isAssigningMailToProperty, downloadDocument)}
                <DeleteModalComponent
                tagType={tagType}
                data={rows}
                modalOpen={modalOpen}
                handleDeleteClose={handleDeleteClose}
                toBeDeletedItem={toBeDeletedItem}
                setToBeDeletedItem={setToBeDeletedItem}
                removeRequestData={removeRequestData}
                />
            </>
        )

    }

    const tbodyHeight = tagType !== 'Mail' ? `${window.innerHeight - responsiveHeight}px` : `${window.innerHeight - responsiveHeight + 48}px`
    const mailOrEmailTableHead = tagType === 'Mail' ? ['checkbox','proceedBtn','downloadBtn','','TotalCount','','','','',''] : ['checkbox','proceedBtn','','','TotalCount','','','']
    return (
        <div
            style={{
                width: '100%',
                borderRadius: '4px',
                borderBottom: isBottomBorderAvailable ? '1px solid #E8E8E8' : 'none'
            }}
        >
            {isFetching || loading ? <LinearProgress style={{ height: "2px" }} /> : null}
            {isMailLoading && <LinearProgress style={{ height: "2px" }} />}
            <table className='table-container'>
                <thead style={{ margin: '0 auto',display: tagType === 'Mail' || tagType === 'Email' ? 'none' : 'block' }}>
                    <tr className="table-header">
                        {
                            headers.map((header: string, index: number) => {
                                return <th
                                    style={{wordBreak: 'keep-all', width: tableRowWidth(index), minWidth: tagType == 'Mail' ? tableRowWidth(index) : ''}}
                                    key={header}
                                    className="table-header-title-container">
                                    {header}
                                </th>
                            })
                        }
                    </tr>
                </thead>
                <tbody ref={tableRef} style={{ height: tbodyHeight, width: 'calc( 100% + 2px)' }}>
                    {
                        (tagType === 'Mail' || tagType === 'Email') && selectedMails.length === 0 &&
                        <thead style={{ margin: '0 auto', position:'sticky', top:'0', zIndex: '900' }}>
                            <tr className="table-header">
                                {
                                    headers.map((header: string, index: number) => {
                                        return <th
                                            style={{ width: tableRowWidth(index), minWidth: tagType == 'Mail' || tagType == 'Email' ? tableRowWidth(index) : ''}}
                                            key={header}
                                            className="table-header-title-container">
                                            {
                                                header === 'checkbox' ? checkBoxComponent(index,true,{ checkedAll: true },selectedMails, updateSelectedMails, rows) : <>{header}</>
                                                
                                            }
                                        </th>
                                    })
                                }
                            </tr>
                        </thead>
                    }
                    {
                        (tagType === 'Mail' ||  tagType === 'Email') && selectedMails.length > 0 &&
                        <thead style={{ margin: '0 auto', position:'sticky', top:'0', zIndex: '900' }}>
                            <tr className="table-header">
                                {
                                    mailOrEmailTableHead.map((header: string, index: number) => {
                                        let width = tableRowWidth(index);
                                        return <th
                                            style={{ minWidth: width }}
                                            key={index}
                                            className="table-header-title-container">
                                            {
                                                header === 'proceedBtn' && 
                                                <div>
                                                    <Button
                                                        color="primary"
                                                        style={{
                                                          color:'white',
                                                          minWidth: '100%',
                                                          textAlign:'start'
                                                        }}
                                                        onClick={async ()=>{
                                                            updateIsMailLoading(true);
                                                            for(let selectedMail of selectedMails) {
                                                                const objectId = selectedMail.data.objectId
                                                                if(selectedMail.data.status === 'Processing' || selectedMail.data.status === 'Assigned') continue;
                                                                await updateMail(objectId,'Processing')
                                                                stateUpdate(objectId, 'Processing')
                                                            }
                                                            updateSelectedMails([]);
                                                            updateIsMailLoading(false);
                                                        }}
                                                        variant="contained">
                                                            Move To Processing
                                                    </Button>
                                                </div>
                                            }
                                            {
                                                header === 'downloadBtn' && tagType === 'Mail' &&
                                                <div>
                                                    <Button
                                                        startIcon={
                                                            <GetAppOutlined style={{ color: 'skyblue' }} color='primary' />
                                                        }
                                                        style={{
                                                          background:'white',
                                                        }} 
                                                        onClick={async ()=>{
                                                            for(let selectedMail of selectedMails) {
                                                                const name = selectedMail.data.attachmentDetails.name;
                                                                const { data } = await fetchSignedUrlFromS3(`${config.HOA_MAILS_BUCKET}/${name}`)
                                                                window.open(data, '_blank');
                                                            }
                                                        }}
                                                        variant="contained">
                                                           Download
                                                    </Button>
                                                </div>
                                            }
                                            {
                                                header === 'TotalCount' &&  <span>{`${selectedMails.length} Items Selected`}</span>
                                            }
                                            {
                                                header === 'checkbox' &&  checkBoxComponent(index, true, { clearFilter: true } ,selectedMails, updateSelectedMails)
                                            }
                                        </th>
                                    })
                                }
                            </tr>
                        </thead>
                    }
                    {!isFetching && rows.length === 0 &&
                        <div className="center-text">No Result Found!!!</div>
                    }
                    {rows.map((row: any, rIndex: number) => (
                        <>
                            <tr className="table-body" key={rIndex}>
                            {
                                columns.map((column: string,index:number) =>
                                    <td
                                        style={{ width: tableRowWidth(index), minWidth: tagType == 'Mail' || tagType == 'Email' ? tableRowWidth(index) : ''}}
                                        key={`${index}-${column}`}
                                        onClick={(e) => onIconBtnClick(e, row, tagType === 'Mail' ? 'assign' : 'view', tagType)}
                                        className={`table-body-container ${tagType === "Hoa" && (index === 4 || index === 5) ? `td-center` : ''}`}>
                                        {
                                            column === 'checkbox' ? checkBoxComponent(rIndex, false, row,selectedMails, updateSelectedMails) :
                                            column === 'hover' ? hoverBtnsComponent(mailOrEmail, setMailOrEmail, setSelectedRowId, setMailLogModalOpen, downloadDocument, tagType,onIconBtnClick, onDeleteIconClick, row, isAssigningMailToProperty, handleMailAssignedToProperty, selectedProperty, toggleDocumentDetails, openedDocumentId, handleAccordion, openRequestId, retryWebhook, setDocumentLogModalOpen) :
                                            validColumnValue(row[column],index, row.objectId, row)
                                        }
                                    </td>
                                )
                            }
                            </tr>
                            {
                                tagType === "Requests" &&
                                <Collapse in={row.objectId === openRequestId} key={openRequestId} style={{backgroundColor: '#FAFAFA'}}>
                                    <div style={{ background: "#FAFAFA", padding: 14, border: "1px solid #e8e8e8", display: "flex" }}>
                                        <div style={{ width: '50%', textAlign: "justify" }}>
                                        <div className="sub-title-text" style={{marginBottom:"18px", color: "#787878"}}>Description of Request</div>
                                            <div className="helperText">{accordionData}</div>
                                        </div>
                                    </div>
                                </Collapse>
                            }
                        </>
                    ))}
                </tbody>
            </table>
            <DeleteModalComponent
                tagType={tagType}
                data={rows}
                modalOpen={modalOpen}
                handleDeleteClose={handleDeleteClose}
                toBeDeletedItem={toBeDeletedItem}
                setToBeDeletedItem={setToBeDeletedItem}
                removeRequestData={removeRequestData}
            />
            <MailLogComponent
                isMailLogModalOpen={isMailLogModalOpen}
                mailLogModalClose={mailLogModalClose}
                selectedRowId={selectedRowId}
                setSelectedRowId={setSelectedRowId}
                mailOrEmail={mailOrEmail}
                responsiveHeight={responsiveHeight}
            />
            <DocumentLogComponent 
                isDocumentLogModalOpen={isDocumentLogModalOpen}
                documentLogModalClose={documentLogModalClose}
                selectedRowId={selectedRowId}
                setSelectedRowId={setSelectedRowId}
                responsiveHeight={responsiveHeight}
            />
        </div>
    )
}

const checkBoxComponent = (index: number, isHeader:boolean, selectedData:any,selectedMails:any,updateSelectedMails:any, allRowData:any = []) => {

	const handleChange = (event: any) => {
		event.stopPropagation();

        if(isHeader && selectedData.clearFilter) {
            //! when unchecking selected
            updateSelectedMails([]);
            return;
        }
        if(isHeader && selectedData.checkedAll) {
            //! when checking all selected
            let tmpAllData:any = [];
            allRowData.forEach((element:any,index:number) => {
                tmpAllData.push({
                    index:index,
                    data:element
                })
            });
            updateSelectedMails([...tmpAllData]);
            return;
        }
        let tmp = selectedMails || [];
        if(event.target.checked) {
            tmp.push({
                index:index,
                data:selectedData
            })
            updateSelectedMails([...tmp]);
        } else {
            tmp=tmp.filter(((value:any) => value.index !== index))
            updateSelectedMails(tmp);
        }

	};

    if(!selectedData.objectId && selectedData.checkedAll) {
        return(
            <FormControlLabel
                key={`index-${index}`}
                onClick={(event: any) => {
                    event.stopPropagation();
                }}
                onChange={handleChange}
                control={<Checkbox />}
                label=""
		/>
        )
    }

    if(!selectedData.objectId && selectedData.clearFilter) {
        return(
            <FormControlLabel
                key={`index-${index}`}
                onClick={(event: any) => {
                    event.stopPropagation();
                }}
                onChange={handleChange}
                control={<Checkbox indeterminate={isHeader && selectedData.clearFilter} />}
                label=""
		/>
        )
    }

	return selectedData.objectId &&(
		<FormControlLabel
            key={`index-${index}`}
			onClick={(event: any) => {
				event.stopPropagation();
			}}
			onChange={handleChange}
			control={<Checkbox checked={selectedMails.length > 0 && selectedMails.find(((mail:any) => mail.data.objectId === selectedData.objectId)) || false} />}
			label=""
		/>
	);

    
};

const hoverBtnsComponent = (mailOrEmail: any, setMailOrEmail: any, setSelectedRowId: any, setMailLogModalOpen: any, downloadDocument: any, tagType:any,onIconBtnClick:any,onDeleteIconClick: any,data:any, isAssigningMailToProperty:boolean, handleMailAssignedToProperty: any, selectedProperty: any, toggleDocumentDetails:any, openedDocumentId: any, handleAccordion: any, openRequestId: any, retryWebhook: any, setDocumentLogModalOpen: any) => {

    function MouseOver(event: any) {
        event.target.style.color = '#3576E5';
    }
    function MouseOut(event: any) {
        event.target.style.color = "";
    }
    const mailModalToggle = (e: any, id: string, type: string) => {
        e.stopPropagation();
        setSelectedRowId(id)
        setMailOrEmail(type);
        setMailLogModalOpen(true);
    }

    const documentModalToggle = (e: any, id: string) => {
        e.stopPropagation();
        setSelectedRowId(id)
        setDocumentLogModalOpen(true);
    }

    return (
        <div className="icon-container-hover">
            {
                tagType === 'Hoa' &&
                <Tooltip title="View Hoa">
                <IconButton onClick={(e)=>onIconBtnClick(e, data,'view')} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                    <HomeOutlined id='icon-componenet' />
                </IconButton>
                </Tooltip>
            }
            {
                tagType === 'Property' && !isAssigningMailToProperty &&
                <Tooltip title="View Property">
                <IconButton onClick={(e)=>onIconBtnClick(e, data,'view')} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                    <HomeWorkOutlined id='icon-componenet' />
                </IconButton>
                </Tooltip>
            }
            {
                tagType === 'Property' && isAssigningMailToProperty && 
                <Radio
                    checked={selectedProperty?.objectId == data?.objectId}
                    onChange={() =>  handleMailAssignedToProperty(data)}
                    // value="a"
                    name="radio-buttons"
                />
            }
            {
                tagType === 'Municipality' &&
                <Tooltip title="View Municipality">
                <IconButton onClick={(e)=>onIconBtnClick(e, data,'view')} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                    <AccountBalanceOutlined id='icon-componenet' />
                </IconButton>
                </Tooltip>
            }
            {
                tagType === 'Email' &&
                <Tooltip title="View Email">
                <IconButton onClick={(e)=>onIconBtnClick(e, data,'view')} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                    <Drafts id='icon-componenet' />
                </IconButton>
                </Tooltip>
            }
            {
                tagType === 'Mail' && (
                    <>
                        <Tooltip title="Download Document">
                            <IconButton style={{marginTop: 5 }} onClick={(e)=>downloadDocument(e, data.attachmentDetails)} onMouseOver={MouseOver} onMouseOut={MouseOut} href={data?.file} target="_blank">
                                <GetAppOutlined id='icon-componenet' />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="View Document">
                            <IconButton style={{ marginTop: 5 }} onClick={(e)=>onIconBtnClick(e, data,'view', tagType)} onMouseOver={MouseOver} onMouseOut={MouseOut} href={data?.file} target="_blank">
                                <MailOutline id='icon-componenet' />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="View Timeline">
                            <IconButton style={{ marginTop: 5 }} onClick={(e) => mailModalToggle(e, data.objectId, 'mail')} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                                <Timeline id='icon-componenet' />
                            </IconButton>
                        </Tooltip>
                    </>)
            }
            {
                tagType === 'Document' && (
                    <>
                    <Tooltip title="Download Document">
                        <IconButton onClick={()=>downloadDocument(data)} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                            <GetAppOutlined id='icon-componenet' />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="View Timeline">
                        <IconButton style={{ marginTop: 5 }} onClick={(e) => documentModalToggle(e, data.objectId)} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                            <Timeline id='icon-componenet' />
                        </IconButton>
                    </Tooltip>
                    </>
                )
            }
            {
                tagType === 'Requests' && (
                    <>
                    <IconButton onClick={() => handleAccordion(data)}>
                        {
                            openRequestId === data?.objectId ? 
                            <KeyboardArrowUp/>
                            :
                            <KeyboardArrowDown/>
                        }
                    </IconButton>
                    { datastore.isUserPermitted('Requests', '', 'delete') &&
                    <IconButton onClick={(e)=>onDeleteIconClick(e, data)} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                        <DeleteOutlineIcon id='icon-componenet' />
                    </IconButton> }
                    </>
                )
            }
            {
                tagType !== 'DataFieldConfigurator' && tagType !== 'Mail' && tagType !== 'Requests' && tagType !== 'Document' && tagType !== 'Hoa' && tagType !== 'TriggerNotificationLog' && !isAssigningMailToProperty && datastore.isUserPermitted(tagType,'update') &&
                <Tooltip title={`Edit ${tagType}`}>
                <IconButton onClick={(e)=>onIconBtnClick(e, data, tagType === "Webhook" ? 'modal-update' : 'update')} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                    <Edit id='icon-componenet' />
                </IconButton>
                </Tooltip>
            }
            {
                tagType === 'Email' && (
                    <Tooltip title="View Timeline">
                        <IconButton style={{ marginTop: 5 }} onClick={(e) => mailModalToggle(e, data.objectId, 'email')} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                            <Timeline id='icon-componenet' />
                        </IconButton>
                    </Tooltip>
                )
            }
            {
                tagType === 'TriggerNotificationLog' && data?.status === false && (
                    <Tooltip title="Retry">
                        <IconButton style={{ marginTop: 5 }} onClick={(e) => retryWebhook(data)} onMouseOver={MouseOver} onMouseOut={MouseOut}>
                            <Replay id='icon-componenet' />
                        </IconButton>
                    </Tooltip>
                )
            }
        </div>
    )
}


const responsiveTable = (headers: any, tableRef: any, rows: any, columns: any, isFetching: boolean, isBottomBorderAvailable: any,tagType:any, onIconBtnClick:any, validColumnValue:any, onDeleteIconClick: any, isAssigningMailToProperty: any, downloadDocument: any) => {

    return (
        <div
            ref={tableRef}
            style={{
                width: 'calc( 100% + 2px)',
                height: window.innerHeight - responsiveHeight,
                overflow: 'scroll',
                borderBottom: isBottomBorderAvailable ? '1px solid #E8E8E8' : 'none'
            }}>
            <table id='responsive-table'>
                <tbody>
                    {!isFetching && rows.length === 0 &&
                        <div className="center-text">No Result Found!!!</div>
                    }
                    {
                        rows.map((row: any, index: number) => {

                            return (
                                <tr key={index}>
                                    {
                                        columns.map((column: any, index: number) => {
                                            return (
                                                <td key={`${index}-${column}`} data-label={headers[index]}  onClick={(e)=>tagType==="DataFieldConfigurator"&& onIconBtnClick(e, row,'view',tagType)}>
                                                    {
                                                        column !== 'hover' ? <span className="responsive-body-value">{validColumnValue(row[column],index, row)}</span> :
                                                            <div>
                                                                {  tagType === 'Hoa' && <HomeOutlined onClick={(e)=>onIconBtnClick(e, row,'view')} style={{ color: 'gray', marginRight: '10px' }} id='icon-componenet' />}
                                                                {  tagType === 'Property' && <AccountBalanceOutlined onClick={(e)=>onIconBtnClick(e, row,'view')} style={{ color: 'gray', marginRight: '10px' }} id='icon-componenet' /> }
                                                                {  tagType === 'Municipality' && <HomeWorkOutlined onClick={(e)=>onIconBtnClick(e, row,'view')} style={{ color: 'gray', marginRight: '10px' }} id='icon-componenet' /> }
                                                                { tagType === 'Requests' && datastore.isUserPermitted(tagType, '', 'delete') && 
                                                                <DeleteOutlineIcon onClick={(e)=>onDeleteIconClick(e, row)} style={{ color: 'gray', marginRight: '10px' }} id='icon-componenet' />
                                                                }
                                                                { tagType === 'Document' && 
                                                                <IconButton onClick={()=>downloadDocument(row)}>
                                                                    <GetAppOutlined style={{ color: 'gray', marginRight: '10px' }} id='icon-componenet' />
                                                                </IconButton>
                                                                }
                                                                {tagType !== "DataFieldConfigurator" && tagType !== 'Mail' && tagType !== 'Requests' && tagType !== 'Document' && !isAssigningMailToProperty && datastore.isUserPermitted(tagType, 'update') &&
                                                                    <Edit onClick={(e) => onIconBtnClick(e, row, 'update')} style={{ color: 'gray', marginRight: '10px' }} id='icon-componenet' />
                                                                }
                                                            </div>
                                                    }

                                                </td>
                                            )
                                        })
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

// delete modal
const DeleteModalComponent = ({tagType, data, toBeDeletedItem, setToBeDeletedItem, removeRequestData, updateRequestsData, updateDocumentData, handleDeleteClose, modalOpen}: any) => {
    const [isLoading, setLoading] = useState(false);
    const onClose = () => {
		handleDeleteClose();
	};

    const handleDelete = async () => {
        setLoading(true);
        if(tagType === 'Requests'){
            removeRequestData(toBeDeletedItem)
        }
        setLoading(false);
        onClose();
    }

return (
    <Modal open={modalOpen} onClose={onClose}>
        <Container
            style={{
                background: "white",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "548px",
                maxHeight: "645px",
                overflow: "auto",
                borderRadius: "8px 8px 0px 0px",
                padding: "0px",
            }}
        >
            <div className="modal-wrapper-doc">
                <Stack 
                    style={{ 
                        alignItems: "center",
                        padding: '12px 24px',
                        gap: '12px',	
                    }}
                    direction={"row"}
                    spacing={1}
                    justifyContent="flex-between">
                    <DeleteForeverIcon 
                        style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
                    <div>
                        <h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
                        <p style={{color: '#787878'}}>This item will be deleted forever</p>
                    </div>
                </Stack>
                
                <Stack
                    style={{ marginTop: "24px" }}
                    direction={"row"}
                    spacing={1}
                    justifyContent="flex-end"
                >
                    {!isLoading ? (
                        <>
                            <Button onClick={() => onClose()} variant="outlined">
                                Cancel
                            </Button>
                            <Button onClick={handleDelete} variant="contained">
                                Delete
                            </Button>
                        </>
                    ) : (
                        <LoadingButton
                            loading
                            loadingIndicator="Deleting..."
                            variant="outlined"
                        >
                            Deleting Data
                        </LoadingButton>
                    )}
                </Stack>
            </div>
        </Container>
    </Modal>
)
}
